export default __webpack_public_path__ + "svg/calendar/2025/2/mayo.svg?57a16f55";